import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PreviewSheetData } from '@app/models';
import { Timezone } from '@app/models/organization.model';
import { BroadcastService } from '@app/pages/broadcast/services/broadcast.service';
import { BroadcastStatus, DATE_TIME_FORMATS, DUPLICATE_COMMS_DIALOG, GENERAL_MESSAGES, TOOLTIP_DELAY } from '@app/shared';

@Component({
    selector: 'app-duplicate-communications-list',
    templateUrl: './duplicate-communications-list.component.html',
    styleUrls: ['./duplicate-communications-list.component.scss'],
    standalone: false
})
export class DuplicateCommunicationsListComponent implements OnInit {
  broadcastDisplayedColumns: string[] = ['id', 'message', 'schedule_time', 'comm_status', 'channels', 'interests'];
  surveyDisplayedColumns: string[] = ['id', 'message', 'schedule_time', 'comm_status', 'channels', 'interests'];
  broadcastDataSource: any;
  surveryDataSource: any;
  timezone: any;
  generalMessages = GENERAL_MESSAGES;
  dateTimeFormats = DATE_TIME_FORMATS;
  dialogMessages = DUPLICATE_COMMS_DIALOG;
  tooltipDelay = TOOLTIP_DELAY.DATA_TABLE;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { data: PreviewSheetData, timezone: Timezone },
    private readonly _matDialogRef: MatDialogRef<DuplicateCommunicationsListComponent>,
    private readonly _broadcastService: BroadcastService
  ) { }

  ngOnInit(): void {
    this.timezone = this.data.timezone;
    const commsDuplicateData = this.data.data.warnMessage?.find((message) => message.name === 'COMMS_DUPLICATE');
    this.broadcastDataSource = commsDuplicateData?.data?.broadcasts;
    this.surveryDataSource = commsDuplicateData?.data?.surveys;
  }

  getStatusValue(status: string) {
    if (status.toLowerCase().includes('scheduled')) 
      return { 
        ...BroadcastStatus.queued, 
        value: BroadcastStatus.queued.label 
      };
    return this._broadcastService.getFormStatusByValue(status);
  }

  close() {
    this._matDialogRef.close();
  }
}
